<template>
    <BasePanel
        headline='lang_GENERIC_AZ_PANEL_CAPTION_METADATA'
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-row class="pt-4">
                <!-- 1st column -->
                <v-col cols="3">
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Language"
                            :items="dropdownLanguages" 
                            :label="$t('lang_GENERIC_CAPTION_LANGUAGE')"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-language'"
                            :clearable="false"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDatePicker 
                            :context="context"
                            field="FoundingDate"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOUNDING_DATE')"
                            :alvqa="alvqa + '-datepicker-founding-date'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="CustomerNumber"
                            :label="$t('lang_GENERIC_AZ_CAPTION_CUSTOMER_NUMBER')"
                            :alvqa="alvqa + '-textfield-customer-number'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="Currency"
                            :items="dropdownCurrency" 
                            :clearable="true"
                            :label="$t('lang_GENERIC_CAPTION_CURRENCY')"
                            :alvqa="alvqa + '-dropdown-currency'"
                        /> 
                    </v-row>
                </v-col>

                <!-- 2nd column -->
                <v-col cols="4">
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="LabelCompany"
                            :items="labelCompanyItems" 
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_LABEL_COMPANY')"
                            :selection="true"
                            itemText="name"
                            itemValue="alvId"
                            :alvqa="alvqa + '-dropdown-label-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Labelcode"
                            :label="$t('lang_AZ_PERSONS_CAPTION_LABELCODE')"
                            :alvqa="alvqa + '-textfield-labelcode'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TonisNextPrefix"
                            :label="$t('lang_AZ_GROUPS_CAPTION_TONIS_NEXT_PREFIX')"
                            :alvqa="alvqa + '-textfield-tonis-next-prefix'"
                        /> 
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="TonisNextSuffix"
                            :label="$t('lang_AZ_GROUPS_CAPTION_TONIS_NEXT_SUFFIX')"
                            :alvqa="alvqa + '-textfield-tonis-next-suffix'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="TasFromPricelist"
                            :items="dropdownYesNo" 
                            :label="$t('lang_AZ_GROUPS_CAPTION_TAS_FROM_PRICELIST')"
                            :alvqa="alvqa + '-dropdown-tas-from-pricelist'"
                        /> 
                    </v-row>
                    <v-row>
                        <!-- inv_lagername in DB -->
                        <BaseEditPageTextField 
                            :context="context"
                            field="WarehouseName"
                            :label="$t('lang_AZ_GROUPS_CAPTION_WAREHOUSE_NAME')"
                            :alvqa="alvqa + '-textfield-warehouse-name'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FocFirstShipment"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_FIRST_SHIPMENT')"
                            :alvqa="alvqa + '-textfield-foc-first-shipment'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="FocAllShipments"
                            :label="$t('lang_AZ_GROUPS_CAPTION_FOC_ALL_SHIPMENTS')"
                            :alvqa="alvqa + '-textfield-foc-all-shipments'"
                            suffix="%"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="HandlingFee"
                            :label="$t('lang_AZ_GROUPS_CAPTION_HANDLING_FEE')"
                            :alvqa="alvqa + '-textfield-handling-fee'"
                        />
                    </v-row>
                </v-col>

                <!-- 3rd column -->
                <v-col cols="5">
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="PublishingCompany"
                            :items="publishingCompanyItems" 
                            :label="$t('lang_GENERIC_AZ_CAPTION_ASSIGN_TO_PUBLISHING_COMPANY')" 
                            :selection="true"
                            itemText="name"
                            itemValue="alvId"
                            :alvqa="alvqa + '-dropdown-publishing-company'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="GemaMember"
                            :items="dropdownYesNo" 
                            :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_MEMBER')"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-gema-member'"
                        />
                    </v-row>
                    <v-row>
                        <BaseEditPageDropdown 
                            :context="context"
                            field="BgNineSplit"
                            :items="dropdownYesNo" 
                            :label="$t('lang_GENERIC_AZ_CAPTION_BG9_FOR_GEMA_MEMBER')"
                            :selection="true"
                            :alvqa="alvqa + '-dropdown-bg-nine-split'"
                        />
                    </v-row>
                </v-col>

            </v-row>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import {    DropdownGenericYesNo,
            DropdownAzMetadataLanguages,
            DropdownCurrencies,
            } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "MetadataPanel",
    components: {
        BasePanel,
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageDatePicker,
    },
    data() {
        return {
            context: "AzGroupsMetadata",
            alvqa: "az-groups-edit-form-panel-metadata",
        }
    },
    computed: {       
        dropdownYesNo()         { return DropdownGenericYesNo },
        dropdownLanguages()     { return DropdownAzMetadataLanguages },
        dropdownCurrency() { return DropdownCurrencies },
        labelCompanyItems() { 
            let companyArr
            let companies = this.$store.getters.getLabelCompanies 

            if(companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-label-company-' + element.alvId
                });
            }

            return companyArr
        },

        publishingCompanyItems() { 
            let companyArr
            let companies = this.$store.getters.getPublishingCompanies 

            if(companies !== undefined) {
                companyArr = JSON.parse(JSON.stringify(companies))
                companyArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-publishing-company-' + element.alvId
                });
            }

            return companyArr
        },

    },
    created() {
        this.$store.commit('setLanguages')
    }
}
</script>